<template>
  <div v-if="isVisible" class="inactivity-modal-overlay">
    <div class="inactivity-modal">
      <div class="modal-icon">
        <i class="fa-solid fa-clock text-warning"></i>
      </div>
      
      <h3 class="modal-title">Sessão Expirando</h3>
      
      <p class="modal-message">
        Sua sessão expirará em <strong>{{ remainingTime }}</strong> segundos devido à inatividade.
      </p>
      
      <div class="progress-bar">
        <div 
          class="progress-fill" 
          :style="{ width: progressWidth + '%' }"
        ></div>
      </div>
      
      <div class="modal-actions">
        <button 
          class="btn-primary" 
          @click="$emit('continue')"
        >
          <i class="fa-solid fa-refresh"></i>
          Continuar Sessão
        </button>
        
        <button 
          class="btn-secondary" 
          @click="$emit('logout')"
        >
          <i class="fa-solid fa-sign-out-alt"></i>
          Fazer Logout
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InactivityWarning',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    remainingTime: {
      type: Number,
      default: 30
    }
  },
  emits: ['continue', 'logout'],
  computed: {
    progressWidth() {
      return (this.remainingTime / 30) * 100
    }
  }
}
</script>

<style scoped>
.inactivity-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.inactivity-modal {
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border: 1px solid var(--border-color);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #f59e0b;
}

.modal-title {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.modal-message {
  color: var(--text-secondary);
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.modal-message strong {
  color: #f59e0b;
  font-weight: 600;
}

.progress-bar {
  background: #e5e7eb;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 2rem;
}

[data-theme="dark"] .progress-bar {
  background: #374151;
}

.progress-fill {
  background: linear-gradient(90deg, #f59e0b, #ef4444);
  height: 100%;
  border-radius: 4px;
  transition: width 1s linear;
}

.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary,
.btn-secondary {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.btn-primary {
  background: var(--accent-color);
  color: white;
}

.btn-primary:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

.btn-secondary {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
}

.btn-secondary:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border-color: #ef4444;
}

@media (max-width: 480px) {
  .inactivity-modal {
    padding: 1.5rem;
    margin: 1rem;
  }
  
  .modal-actions {
    flex-direction: column;
  }
  
  .btn-primary,
  .btn-secondary {
    width: 100%;
    justify-content: center;
  }
}
</style> 